export const certificateStatus = {
  ACCEPTED: "Accepted",
  SIGNATURE_ERROR: "SignatureError",
  CERTIFICATE_EXPIRED:"CertificateExpired",
  CERTIFICATE_REVOKED:"CertificateRevoked",
   NO_CERTIFICATE_AVAILABLE:"NoCertificateAvailable",
   CERT_CHAIN_ERROR:"CertChainError",
   CONTRACT_CANCELLED:"ContractCancelled"
}